import {useEffect} from 'react';
import {appName} from '../components/landing/content';
import {findPageName} from '../support/pageTitles';

/**
 * Единый заголовок вкладки: `{раздел} · Clothes` (QA-15, U15 от 15.09.2026).
 *
 * Раньше каждая страница писала `document.title` сама: формат был разный
 * («Clothes :: Образ дня», «Куртка :: Clothes», «Clothes :: Home»), часть страниц
 * не писала ничего — и во вкладке оставалось имя предыдущего раздела (стилист
 * отображался как «Подписка и лимиты»).
 *
 * Без аргумента имя раздела берётся из адреса страницы ({@link findPageName}), поэтому
 * странице достаточно вызвать хук. Аргумент нужен, когда заголовок зависит от данных:
 * имя вещи, название образа или списка. `null`/`undefined` в аргументе — «данные ещё не
 * пришли»: заголовок остаётся на имени раздела, а не мигает пустым.
 *
 * Путь читается из `window.location`, а не из `useLocation()`: хук вызывают и экраны
 * публичного контура, которые монтируются в тестах и в шелле авторизации без роутера,
 * а страница в любом случае монтируется заново при переходе между разделами.
 *
 * При уходе со страницы заголовок сбрасывается на имя приложения — так следующий раздел
 * не наследует чужой заголовок, даже если сам хук не вызовет.
 */
export function useDocumentTitle(title?: string | null): void {
    useEffect(() => {
        const app = appName();
        const section = (title ?? '').trim() || findPageName(window.location.pathname);
        document.title = section ? `${section} · ${app}` : app;
        return () => {
            document.title = app;
        };
    }, [title]);
}

export default useDocumentTitle;
